<template src='./auditModal.pug' lang='pug'></template>

<script>
import moment from 'moment'
import Modal from '../../modals/modal/Modal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import ButtonPrint from '../../buttons/buttonPrint/ButtonPrint'
import language from '../../../../build/language/index'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'AuditModal',

  components: {
    Modal,
    ButtonPrimary,
    ButtonPrint
  },

  props: {
    audit: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      modalTitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),
      modalSubtitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),
      userName: '',
      login: '',
      accessProfile: '',
      functionality: '',
      transaction: '',
      transactionDate: '',
      ip: '',
      workStation: '',
      entity: '',
      entityId: ''
    }
  },

  watch: {
    audit () {
      this.modalTitle = this.audit.tituloModal
      this.userName = this.audit.nomeUsuario
      this.login = this.audit.login
      this.accessProfile = this.audit.nomePerfil
      this.functionality = this.audit.funcionalidade ? this.audit.funcionalidade.nome : ''
      this.transaction = this.audit.transacao ? this.audit.transacao.nome : ''
      this.transactionDate = moment(this.audit.dataTransacao).format('DD/MM/YYYY HH:mm:ss')
      this.ip = this.audit.numeroIP
      this.workStation = this.audit.numeroIP
      this.entity = this.audit.entidade ? this.audit.entidade.numero : ''
      this.entityId = this.audit.idEntidade
      this.loadData()
    }
  },

  methods: {
    loadData () {
      $('#treeView > li').empty()
      let xmlText = null
      let xmlObjetct = null

      xmlText = this.audit.xmlEntidade
      xmlObjetct = jQuery.parseXML(xmlText)
      this.toXml(xmlObjetct)
    },

    toXml (tree) {
      this.traverse($('#treeView li'), tree.firstChild)
      // this – is an &mdash
      $('<b>-</b>').prependTo('#treeView li:has(li)').click(function () {
        let sign = $(this).text()
        if (sign === '-') {
          let next = $(this).text('+').next()[0]
          next.innerText = $(this).next().text() + ' ...'
          $(this).text('+').next().next().hide()
        } else {
          let next = $(this).text('+').next()[0]
          next.innerText = $(this).next().text().replace(' ...', '')
          $(this).text('-').next().next().show()
        }
      })
    },

    traverse (node, tree) {
      let children = $(tree).children()
      let self = this

      if (tree.children && tree.children.length) {
        children = tree.children

        node.append('<label>' + tree.nodeName + '</label>')
        let ul = $('<ul>').appendTo(node)

        var li = null

        for (let i = 0; i < children.length; i++) {
          li = $('<li>').appendTo(ul)
          self.traverse(li, children[i])
        }
      } else {
        if (tree.nodeName === 'lang') {
          node.append('<label>linguagemDoSistema: </label>')
        } else {
          node.append('<label>' + tree.nodeName + ': </label>')
        }

        if ($(tree).text() === 'true') {
          $('<span> Sim</span>').appendTo(node)
        } else if ($(tree).text() === 'false') {
          $('<span> Não</span>').appendTo(node)
        } else {
          if ($(tree).text().length === 10 && ($(tree).text().split('-').length - 1) === 2) {
            $('<span> ' + this.handleText($(tree).text()) + '</span>').appendTo(node)
          } else {
            $('<span> ' + $(tree).text() + '</span>').appendTo(node)
          }
        }
      }
    },

    handleText (text) {
      return moment(text).format('DD/MM/YYYY')
    },

    closeModal () {
      $('#auditModal').modal('hide')
    }
  }
}
</script>

<style>
#auditModal {
  font-family: 'Inter', sans-serif;
  z-index: 100000000;
}

.tree-view {
  margin-top: 10px;
  background-color: rgba(236, 244, 247, 1);
  padding-top:10px;
  max-height: 180px;
  overflow-y: auto;
}

/*Tree view*/
ul#treeView {
  font-family: 'Inter', sans-serif;
 -webkit-padding-start: 15px!important;
  margin-top: 10px
}

#treeView li{
  list-style: none;
  margin: 4px;
  border: none;
  padding-left: 10px;
  background-clip: blue;
  -webkit-padding-start: 0px !important;
  margin-bottom: 8px;
}

#treeView ul {
  padding-left: 1em;
  border-left: solid 1px #1E1F20;
  margin: 0;
  padding: 5px 0 0 0;
  margin-left: 12px;
}

#treeView b {
  background: rgba(0, 94, 120, 1) !important;
  border: solid 1px rgba(0, 94, 120, 1);
  color: rgba(255, 255, 255, 1) !important;
  text-align: center;
  line-height: 9px;
  cursor: pointer;
  margin-left: -15px;
  margin-right: 5px;
  padding: 0px 5px;
}

#treeView span {
  color: #333;
  font-weight: bold;
}

#treeView label {
  padding: 2px 3px;
  font-weight: normal;
}

.modal-auditoria-tit {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

p.modal-auditoria-left-txt {
  font-size: 12px;
  margin-bottom: 5px;
  color: rgba(32, 32, 32, 1);
}
</style>



// WEBPACK FOOTER //
// AuditModal.vue?5f0ef7fb